import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
export class Lightbox {
    constructor(private gallery: HTMLElement) {
        this.init();
    }

    init() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: this.gallery,
            children: 'a',
            pswpModule: () => import('photoswipe'),
            wheelToZoom: true,
            bgClickAction: 'close',
            tapAction: 'close',
            closeOnVerticalDrag: true,
            paddingFn: (viewportSize) => {
                return {
                    top: viewportSize.y * 0.1,
                    right: viewportSize.x * 0.1,
                    bottom: viewportSize.y * 0.1,
                    left: viewportSize.x * 0.1
                };
            },
        });

        lightbox.init();
    }
}

window.addEventListener("load", () => {
    const galleries = document.querySelectorAll<HTMLElement>(".pswp-gallery");

    galleries?.forEach((gallery) => {
        new Lightbox(gallery);
    })
});